<template>
  <v-dialog v-model="dialogShow" persistent width="900">
    <v-card class="dialog">
      <v-card-title class="dialogTitle">
        <p class="dialogTitle-title">场景样例数据</p>
        <v-spacer></v-spacer>
        <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text style="height:662px;padding:30px 0 25px 22px;display:flex;flex-direction:column;">
        <p style="color:#A6A6A6;font-size:16px;">选择添加的样例数据</p>

        <div style="margin-top:27px;overflow:auto;flex:1;" class="myScrollArea">
          <div v-for="(item,index) in exampleList" :key="'exampleDialog'+index" :style="{'margin-right':index!==0 && index%4===3 ? '0' : '16px'}"
               style="width:200px;height:200px;margin-bottom:16px;float:left;">
            <div style="position:relative;width:100%;height:calc(100% - 40px);">
              <v-img :src="item.picture" style="position:absolute;width:100%;height:100%;"></v-img>
              <v-radio-group v-model="exampleRadio" class="exampleRadio">
                <v-radio :value="item.id" color="#14457D"></v-radio>
              </v-radio-group>
            </div>
            <div style="width:100%;height:40px;border:1px solid #e5e5e5;background:#14457D;
            padding:0 5px;font-size:16px;color:#ffffff;text-align:center;">
              <p style="line-height:40px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;">{{item.labelName}}</p>
            </div>
          </div>
        </div>

        <div style="margin-top:30px;margin-right:30px;text-align:right;">
          <v-btn @click="addExample" width="100" height="35" dark depressed color="#1E3A8A" style="border-radius:0;">确定</v-btn>
        </div>


      </v-card-text>
    </v-card>



  </v-dialog>
</template>

<script>
export default {
  name: "SceneExample",
  props:["dialogShow","exampleList"],
  data(){
    return{

      exampleRadio:this.exampleList[0].id,


    }

  },
  methods:{
    closeDialog(){
      this.$emit("closeDialog","")
    },

    //确定选择样例数据
    addExample(){
      this.$parent.addExampleToSceneList(this.exampleRadio)
      this.$emit("closeDialog","")
    }


  },


}
</script>

<style scoped>

.exampleRadio{
  position:absolute;
  margin:4px 0 0 6px;
}


</style>

<style>
/*多选框样式调整*/
.exampleRadio .v-input--selection-controls__ripple{
  display:none;
}
.exampleRadio .theme--light.v-icon{
  border-radius:50%;
  width:16px;
  height:16px;
  color:#4a4a4a;
  background:#ffffff;
}

</style>